import enLang from './entries/en-US';
import esLang from './entries/es_ES';
import arLang from './entries/ar-AR';
import zhLang from './entries/zh-CH';
const AppLocale: any = {
  en: enLang,
  es: esLang,
  ar: arLang,
  zh: zhLang,
};

export default AppLocale;
